import { createSelector } from '@ngrx/store';

import { CONVERSATION_CHANNEL_PREFIX } from '@ninety/platform/models/feedback/conversation-real-time.models';

import { RealTimeStateKey, selectGlobalAppState } from '..';

export const selectRealTimeState = createSelector(selectGlobalAppState, globalState =>
  globalState ? globalState[RealTimeStateKey] : null
);
export const selectChannels = createSelector(selectRealTimeState, state => state.channels);

export function selectConversationChannel(conversationId: string) {
  return createSelector(
    selectChannels,
    channels => channels.find(c => c.channelId === `${CONVERSATION_CHANNEL_PREFIX}${conversationId}`) ?? null
  );
}
